export default __webpack_public_path__ + "static/media/640_private01-jp-web.4ce6cf66.png";